import template from './index.html';
import style from './style.scss';

export default ['productSearchSimple', function () {
    'ngInject';

    return {
        restrict: 'E',
        template: template,
        scope: {
            product: '='
        },
        link: function (scope) {
            scope.style = style;
        }
    };
}];



// WEBPACK FOOTER //
// ./src/app/directives/product/search-simple/index.js